(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sld-trail-winder-temperature-estimator"] && !Shopify.designMode) return;
  try {
    (() => {
    const baseRatings = {
      '2.5': '50°F',
      '3.6': '40°F',
      '5.0': '30°F',
      '6.0': '20°F',
      '7.5': '10°F',
      '10.0': '-5°F',
    };
    const layeredRatings = {
      '2.5|2.5': '30°F to 40°F',
      '2.5|3.6': '20°F to 30°F',
      '2.5|5.0': '10°F to 20°F',
      '2.5|6.0': '5°F to 15°F',
      '3.6|2.5': '20°F to 30°F',
      '3.6|3.6': '10°F to 20°F',
      '3.6|5.0': '5°F to 15°F',
      '3.6|6.0': '0°F to 10°F',
      '5.0|2.5': '10°F to 20°F',
      '5.0|3.6': '5°F to 15°F',
      '5.0|5.0': '-5°F to 5°F',
      '5.0|6.0': '-10°F to 0°F',
      '6.0|2.5': '5°F to 15°F',
      '6.0|3.6': '0°F to 10°F',
      '6.0|5.0': '-10°F to 0°F',
      '6.0|6.0': '-15°F to -5°F',
      '7.5|2.5': '-5°F to 5°F',
      '7.5|3.6': '-10°F to 0°F',
      '7.5|5.0': '-15°F to -5°F',
      '7.5|6.0': '-20°F to -10°F',
      '10.0|2.5': '-15°F to -5°F',
      '10.0|3.6': '-20°F to -10°F',
      '10.0|5.0': 'Below -20°F',
      '10.0|6.0': 'Below -20°F',
    };

    const getResult = (base, addOn) => {
      if (addOn === 'none') {
        return {
          label: 'ESTIMATED COMFORT RATING',
          temperature: baseRatings[base],
          combination: `Apex ${base} oz Trail Winder`,
          belowFloor: false,
        };
      }

      const temperature = layeredRatings[`${base}|${addOn}`];
      const belowFloor = temperature === 'Below -20°F';
      return {
        label: belowFloor ? 'ESTIMATED COMFORT' : 'ESTIMATED COMFORT RANGE',
        temperature,
        combination: `Apex ${base} oz + Apex ${addOn} oz`,
        belowFloor,
      };
    };

    const update = (root) => {
      const base = root.querySelector('[data-sld-temperature-base]');
      const addOn = root.querySelector('[data-sld-temperature-addon]');
      const result = getResult(base.value, addOn.value);
      root.querySelector('[data-sld-temperature-label]').textContent = result.label;
      root.querySelector('[data-sld-temperature-value]').textContent = result.temperature;
      root.querySelector('[data-sld-temperature-combination]').textContent = result.combination;
      root.querySelector('[data-sld-temperature-floor-note]').hidden = !result.belowFloor;
    };

    const initialize = (root) => {
      if (root.dataset.sldTemperatureInitialized === 'true') return;
      root.dataset.sldTemperatureInitialized = 'true';
      root.querySelectorAll('select').forEach((select) => {
        select.addEventListener('change', () => update(root));
      });
      update(root);
    };

    const initializeAll = (scope) => {
      scope.querySelectorAll('[data-sld-temperature-estimator]').forEach(initialize);
    };

    window.SLDTrailWinderTemperatureEstimator = { getResult, update, initializeAll };

    if (typeof document !== 'undefined') {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initializeAll(document));
      } else {
        initializeAll(document);
      }
      document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
